export default function DualStakeHero() {
  return (
    <>
      <div className="flex items-center justify-center text-6xl sm:text-7xl md:text-8xl lg:text-9xl">
        <span className="absolute mx-auto py-4 flex border w-fit bg-gradient-to-r blur-xl from-primary to-teal-500 bg-clip-text box-content text-transparent text-center select-none">
          <span className="font-light">dual</span>
          <span className="font-thin">STAKE</span>
        </span>
        <div className="relative top-0 w-fit h-auto py-4 justify-center flex bg-gradient-to-r items-center from-primary to-teal-500 bg-clip-text text-transparent text-center select-auto">
          <span className="font-semibold">dual</span>
          <span className="font-thin">STAKE</span>
        </div>
      </div>
      <div className="flex items-center justify-center  md:text-2xl lg:text-3xl">
        Liquid Staking. Rewards in your Favorite Assets.
      </div>
    </>
  );
}